import { AxiosResponse } from 'axios';
import http, { fetcher } from 'app/http';
import { getPathnameFromUrl } from 'common/helpers/resolveHost';

export const UrlEncodedHeaders = {
  headers: {
    'content-type': 'application/x-www-form-urlencoded',
  },
};

const makePayment = (url: string, body: any): Promise<AxiosResponse> => {
  const path = getPathnameFromUrl(url);
  return http.post(path, body);
}

const postPaymentValues = (url: string, body: any): Promise<AxiosResponse> => {
  const path = getPathnameFromUrl(url);
  return http.post(path, body);
}

const disableStoredPaymentMethod = (url: string, body: any): Promise<AxiosResponse> => {
  const path = getPathnameFromUrl(url);
  return http.post(path, body);
}

const getPaymentSummary = (url: string): Promise<AxiosResponse> => {
  const path = getPathnameFromUrl(url);
  return fetcher.get(path);
}

export default {
  makePayment,
  postPaymentValues,
  disableStoredPaymentMethod,
  getPaymentSummary,
}